/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BehaviorBipInfoModel } from '../../models/behavior-bip-info-model';

export interface GetCurrentBehaviorBIPInfos$Params {
  patientID?: number;
}

export function GetCurrentBehaviorBIPInfos(http: HttpClient, rootUrl: string, params?: GetCurrentBehaviorBIPInfos$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BehaviorBipInfoModel>>> {
  const rb = new RequestBuilder(rootUrl, GetCurrentBehaviorBIPInfos.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BehaviorBipInfoModel>>;
    })
  );
}

GetCurrentBehaviorBIPInfos.PATH = '/api/Staff/GetCurrentBehaviorBIPInfos';
